import { render, staticRenderFns } from "./LoginAgent.vue?vue&type=template&id=56275bae&scoped=true"
import script from "./LoginAgent.vue?vue&type=script&lang=js"
export * from "./LoginAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56275bae",
  null
  
)

export default component.exports